import { clevertapEvent } from 'utils/clevertap';

const EVENTS = {
  navigate: 'Submit Question Viewed',
};

const ACTIONS = {
  openSubmitQuestion: 'Live Stream Submit Question Selected',
  questioFilled: 'Question Filled',
  questionSubmited: 'Live Stream Question Submitted',
};

const LivestreamQuestionAnalytics = {
  Navigate: {
    View: () => {
      clevertapEvent(EVENTS.navigate);
    },
  },
  Action: {
    openModal: (params) => {
      clevertapEvent(ACTIONS.openSubmitQuestion, params);
    },
    questionFilled: () => {
      clevertapEvent(ACTIONS.questioFilled);
    },
    questionSubmited: (params) => {
      clevertapEvent(ACTIONS.questionSubmited, params);
    },
  },
};

export default LivestreamQuestionAnalytics;
